import React from "react";

import styles from "../../../styles.module.css";

const LogoPNG = ({ width, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      style={style}
      className={style ? "" : styles.widthStyle}
      viewBox="0 0 272 56"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x2="1"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#8163cd" />
          <stop offset="1" stop-color="#f516aa" />
        </linearGradient>
        <filter
          id="Logo_AuditSX"
          x="0"
          y="0"
          width="272"
          height="56"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood flood-opacity="0.2" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Logo_AuditSX-2"
          x="0"
          y="0"
          width="272"
          height="56"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur-2" />
          <feFlood flood-color="#fff" result="color" />
          <feComposite operator="out" in="SourceGraphic" in2="blur-2" />
          <feComposite operator="in" in="color" />
          <feComposite operator="in" in2="SourceGraphic" />
        </filter>
      </defs>
      <g data-type="innerShadowGroup">
        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Logo_AuditSX)">
          <path
            id="Logo_AuditSX-3"
            data-name="Logo AuditSX"
            d="M-81.68,20.124h10.294l4.2-10.608h19.407l4.2,10.608H-33.03L-52.7-27.511h-9.31Zm18.1-19.8,6.1-15.338,6.1,15.338Zm47.6,20.473c5.049,0,8-2.77,10.294-5.811v5.135H4.277V-16.092H-5.689v20.2c0,4.865-2.426,7.365-6.229,7.365s-6.032-2.5-6.032-7.365v-20.2h-9.966V7.354C-27.916,15.665-23.523,20.8-15.983,20.8Zm43.6,0c5.18,0,8.524-2.5,10.949-5.878v5.2h9.966V-29.2H38.567v17.838a13.362,13.362,0,0,0-10.949-5.405c-8.327,0-16,6.622-16,18.716v.135C11.62,14.178,19.422,20.8,27.618,20.8Zm2.557-8.716c-4.655,0-8.589-3.986-8.589-10V1.949c0-6.081,3.934-10,8.589-10s8.524,3.986,8.524,10v.135C38.7,8.1,34.83,12.084,30.175,12.084ZM57.647-20.078H68.138V-29.2H57.647Zm.262,40.2h9.966V-16.092H57.909Zm31.209.608a14.36,14.36,0,0,0,7.868-2.095V10.395a9.9,9.9,0,0,1-4.917,1.284c-2.229,0-3.213-1.149-3.213-3.514V-7.308h8.261v-8.784H88.856v-9.257H78.89v9.257h-4.2v8.784h4.2V9.854C78.89,18.232,83.021,20.732,89.119,20.732Zm33.242.068c8.851,0,15.211-5.27,15.211-12.905V7.759c0-6.892-4.458-10.811-15.08-13.041-10.884-2.3-13.375-5.338-13.375-10.338v-.135c0-4.932,4.458-8.919,11.212-8.919a19.421,19.421,0,0,1,13.7,5.338l2.164-2.77a22.472,22.472,0,0,0-15.736-5.743c-8.524,0-14.752,5.405-14.752,12.432v.135c0,7.162,4.458,11.014,15.473,13.311C131.605.192,134.162,3.1,134.162,8.1v.135c0,5.405-4.721,9.392-11.605,9.392-6.753,0-11.408-2.23-16.457-7.027l-2.229,2.635C109.378,18.3,115.017,20.8,122.36,20.8Zm57.3-47.973L164.06-6.295,148.39-27.173h-4.065L161.9-4,143.669,20.124h4L163.929-1.7l16.326,21.824h4.065L166.027-4l17.637-23.176Z"
            transform="translate(84.68 30.2)"
            fill="url(#linear-gradient)"
          />
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Logo_AuditSX-2)">
          <path
            id="Logo_AuditSX-4"
            data-name="Logo AuditSX"
            d="M-81.68,20.124h10.294l4.2-10.608h19.407l4.2,10.608H-33.03L-52.7-27.511h-9.31Zm18.1-19.8,6.1-15.338,6.1,15.338Zm47.6,20.473c5.049,0,8-2.77,10.294-5.811v5.135H4.277V-16.092H-5.689v20.2c0,4.865-2.426,7.365-6.229,7.365s-6.032-2.5-6.032-7.365v-20.2h-9.966V7.354C-27.916,15.665-23.523,20.8-15.983,20.8Zm43.6,0c5.18,0,8.524-2.5,10.949-5.878v5.2h9.966V-29.2H38.567v17.838a13.362,13.362,0,0,0-10.949-5.405c-8.327,0-16,6.622-16,18.716v.135C11.62,14.178,19.422,20.8,27.618,20.8Zm2.557-8.716c-4.655,0-8.589-3.986-8.589-10V1.949c0-6.081,3.934-10,8.589-10s8.524,3.986,8.524,10v.135C38.7,8.1,34.83,12.084,30.175,12.084ZM57.647-20.078H68.138V-29.2H57.647Zm.262,40.2h9.966V-16.092H57.909Zm31.209.608a14.36,14.36,0,0,0,7.868-2.095V10.395a9.9,9.9,0,0,1-4.917,1.284c-2.229,0-3.213-1.149-3.213-3.514V-7.308h8.261v-8.784H88.856v-9.257H78.89v9.257h-4.2v8.784h4.2V9.854C78.89,18.232,83.021,20.732,89.119,20.732Zm33.242.068c8.851,0,15.211-5.27,15.211-12.905V7.759c0-6.892-4.458-10.811-15.08-13.041-10.884-2.3-13.375-5.338-13.375-10.338v-.135c0-4.932,4.458-8.919,11.212-8.919a19.421,19.421,0,0,1,13.7,5.338l2.164-2.77a22.472,22.472,0,0,0-15.736-5.743c-8.524,0-14.752,5.405-14.752,12.432v.135c0,7.162,4.458,11.014,15.473,13.311C131.605.192,134.162,3.1,134.162,8.1v.135c0,5.405-4.721,9.392-11.605,9.392-6.753,0-11.408-2.23-16.457-7.027l-2.229,2.635C109.378,18.3,115.017,20.8,122.36,20.8Zm57.3-47.973L164.06-6.295,148.39-27.173h-4.065L161.9-4,143.669,20.124h4L163.929-1.7l16.326,21.824h4.065L166.027-4l17.637-23.176Z"
            transform="translate(84.68 30.2)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
    // </div>
  );
};

export default LogoPNG;
